import React from 'react';
import { Container, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const Footer = () => {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  
  // Get the copyright text and ensure year is interpolated
  const copyrightText = t('common.copyright', { year: currentYear });
  // Fallback: if interpolation didn't work, manually replace
  const displayText = copyrightText.includes('{{year}}') || copyrightText.includes('{year}') 
    ? copyrightText.replace(/\{\{year\}\}|\{year\}/g, currentYear)
    : copyrightText;

  return (
    <Navbar
      bg={theme === 'dark' ? 'dark' : 'light'}
      variant={theme === 'dark' ? 'dark' : 'light'}
      fixed="bottom"
      className="footer-navbar"
    >
      <Container fluid className="d-flex justify-content-between align-items-center py-2">
        <div className="copyright-text">
          {displayText}
        </div>
        <div className="d-flex align-items-center gap-3">
          <div className="theme-toggle-container">
            <span className="theme-label me-2">{t('common.light')}</span>
            <label className="theme-switch">
              <input
                type="checkbox"
                checked={theme === 'dark'}
                onChange={toggleTheme}
              />
              <span className="slider"></span>
            </label>
            <span className="theme-label ms-2">{t('common.dark')}</span>
          </div>
          <Link
            to="/settings"
            className="text-decoration-none"
            style={{ 
              color: 'var(--navbar-link-color)',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '32px',
              height: '32px',
            }}
            title="Settings"
          >
            <i className="fas fa-cog" style={{ fontSize: '1.2rem', lineHeight: '1' }}></i>
          </Link>
        </div>
      </Container>
    </Navbar>
  );
};

export default Footer;
